import styled from 'styled-components'

import { theme } from '../../theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 94vh;

  padding: 5% 5% 60px 5%;

  @media (min-width: ${theme.breakpoints.sm}px) {
    width: 70%;
    padding: 1% 5%;
    justify-content: flex-start;
  }
`

export const Title = styled.h1`
  color: ${theme.black};
  font-weight: 600;
  font-size: 22px;
  line-height: 32px;
  margin: 15px 0;

  @media (min-width: ${theme.breakpoints.md}px) {
    font-size: 26px;
    line-height: 36px;
  }

  @media (max-width: ${theme.breakpoints.xs}px) {
    font-size: 18px;
    line-height: 28px;
  }
`

export const Link = styled.p`
  color: ${theme.colors.orangePrimary};
  font-size: 18px;
  font-weight: 600;

  padding: 10px 0;

  width: 100%;
  text-align: center;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: ${theme.breakpoints.sm}px) {
    text-align: start;
    max-width: 200px;
  }
`

export const Description = styled.p`
  font-size: 18px;
  line-height: 28px;
  font-weight: 500;

  @media (max-width: ${theme.breakpoints.xs}px) {
    font-size: 14px;
    line-height: 24px;
  }
`

export const Wrapper = styled.div`
  padding-top: 20px;
  max-width: 600px;
`

export const ButtonWrapper = styled.div`
  padding: 40px 0;
`
